import React from 'react';
import PropTypes from 'prop-types';
import { Tabs } from '@saucelabs/sl-component-tabs';

import Styles from './ConfigsTabs.styles';

const ConfigsTabs = ({ children, ...other }) => (
  <Tabs
    animation={false}
    className={Styles.default}
    id="configs"
    {...other}
  >
    {children}
  </Tabs>
);

ConfigsTabs.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ConfigsTabs;
